import keyBy from 'lodash/keyBy';
import mapValues from 'lodash/mapValues';

export const keyOptionsByValue = (
  options: { label: string, value: string | number }[],
) => mapValues(keyBy(options, 'value'), 'label');
